/**
 * Base environment configuration for Boards app.
 * All environment files should spread this object.
 */
export const environmentBase = {
  appName: 'Boards',
  appSubtitle: 'Provide real-time visibility for waiting audiences',
  registerInterestUrl: '',
  contactEmail: '',
  /**
   * reCAPTCHA v3 site key for public marketing forms. Must match RECAPTCHA_SECRET_KEY on Functions.
   */
  recaptchaSiteKey: '6Le1dbEsAAAAAFNB3-2_zjP_HhXd18GPt3gZ8eca',
};
